import './DefaultLanding.css'
import {useActions} from "../../../hooks/useActions";
import {config} from "../../../config";
import {useState, useEffect} from "react";
import {useTypedSelector} from "../../../hooks/useTypedSelector";
import ButtonPlay from "./ButtonPlay";
import ButtonPlayNewAcc from "./ButtonPlayNewAcc";
import SignInForm from "./SIgnInPopup";
import {MusicService} from "../../../services/MusicService";


const LoginFrameContainer = () => {

    const {isLoading} = useTypedSelector(state => state.auth);
    const {
        setSystemMessage,
        authUserByLoginAndPass,
        startLoadingGame
    } = useActions();

    const [open, setOpen] = useState(false);
    const [buttonPressed, setButtonPressed] = useState(false);

    const [jwtToken, setJwtToken] = useState<string | null>(null);
    const [waitingNutakuToken, setWaitingNutakuToken] = useState(config.isNutaku);

    const rootClasses = ['login-frame-container'];

    useEffect(() => {

        const syncToken = () => {

            const token = localStorage.getItem('jwtToken');

            setJwtToken(token);

            if (config.isNutaku) {
                setWaitingNutakuToken(!token);
            }
        };

        syncToken();

        if (!config.isNutaku) {
            return;
        }

        const handleJwtReady = () => {

            syncToken();
        };

        window.addEventListener('jwt-ready', handleJwtReady);

        // fallback polling (на випадок якщо подія не прийшла)
        const interval = setInterval(() => {
            const token = localStorage.getItem('jwtToken');
            if (token) {
                setJwtToken(token);
                setWaitingNutakuToken(false);
                clearInterval(interval);
            }
        }, 300);

        return () => {
            window.removeEventListener('jwt-ready', handleJwtReady);
            clearInterval(interval);
        };

    }, []);


    const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        if (isLoading) {
            return;
        }
        e.preventDefault();

        const fd = new FormData(e.currentTarget);
        const email = String(fd.get("email") || "");
        const pass = String(fd.get("password") || "");

        try {
            await authUserByLoginAndPass(email, pass);
        } catch (err) {
            setSystemMessage({
                isVisible: true,
                type: 'info',
                text: String(err),
                action: null
            });
            return;
        }

        await startLoadingGame();
        MusicService.playMenuMusic();
    };

    const handleClose = () => {
        setOpen(false);
        setButtonPressed(false);
    };

    return (
        <div className={rootClasses.join(' ')}>
            <div className="login-frame">
                <div className="login-frame-button-container">

                    {!buttonPressed && (

                        config.isNutaku ? (

                            waitingNutakuToken ? null : (
                                jwtToken && (
                                    <div onClick={() => setButtonPressed(true)}>
                                        <ButtonPlay/>
                                    </div>
                                )
                            )

                        ) : (

                            jwtToken ? (
                                <div onClick={() => setButtonPressed(true)}>
                                    <ButtonPlay/>
                                </div>
                            ) : (
                                <>
                                    <div onClick={() => setButtonPressed(true)}>
                                        <ButtonPlayNewAcc/>
                                    </div>

                                    <div
                                        className="signInButton"
                                        onClick={async () => {
                                            setOpen(true);
                                            setButtonPressed(true);
                                        }}
                                    />
                                </>
                            )

                        )

                    )}

                </div>

                {open && (
                    <div
                        className="modal-backdrop"
                        onMouseDown={handleClose}
                        onKeyDown={(e) => e.key === "Escape" && handleClose()}
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="signin-title"
                    >
                        <div
                            className="modal-card"
                            onMouseDown={(e) => e.stopPropagation()}
                        >
                            <h2 id="signin-title">Sign in</h2>

                            <SignInForm
                                isLoading={isLoading}
                                onCancel={handleClose}
                                onSubmit={onSubmit}
                            />
                        </div>
                    </div>
                )}

                <div className="login-frame-text">
                    <h1
                        className="login-frame-logo"
                        style={{fontSize: config.isAndroid ? '10pt' : '18pt'}}
                    >
                        Depraved World
                    </h1>

                    <p style={{fontSize: config.isAndroid ? '8pt' : '14pt'}}>
                        Unleash Your Desires in this 18+ Fantasy Realm Game!
                    </p>

                    <p style={{fontSize: config.isAndroid ? '8pt' : '12pt'}}>
                        Depraved World is a turn-based card game set in a fantasy world. The game’s content includes
                        erotic and pornographic elements.
                        By clicking the ‘Play’ button, you confirm that you are at least 18 years old.
                    </p>
                </div>
            </div>

            <div className={'versionCssClass'}>v.{config.VERSION}</div>
        </div>
    );
};

export default LoginFrameContainer;
